// extracted by mini-css-extract-plugin
export var border = "_1b-8";
export var brand = "_1b-t";
export var button = "_1b-l";
export var center = "_1b-a";
export var centered = "_1b-6";
export var closeButton = "_1b-c";
export var disabledWrapper = "_1b-m";
export var error = "_1b-p";
export var extraLarge = "_1b-4";
export var extraSmall = "_1b-1";
export var fill = "_1b-i";
export var footer = "_1b-h";
export var footerAction = "_1b-j";
export var footerButtons = "_1b-k";
export var header = "_1b-7";
export var headerWithClose = "_1b-d";
export var icon = "_1b-o";
export var info = "_1b-s";
export var inline = "_1b-9";
export var large = "_1b-3";
export var main = "_1b-e";
export var modal = "_1b-0";
export var nearFull = "_1b-5";
export var neutral = "_1b-u";
export var noPadding = "_1b-g";
export var none = "_1b-v";
export var scrollable = "_1b-f";
export var small = "_1b-2";
export var success = "_1b-r";
export var tight = "_1b-n";
export var titleIcon = "_1b-b";
export var warn = "_1b-q";